"use client";

import React from "react";
import s from "../styles";

export default function OrderDetailArea({ data, isY_5, isY_5_label, isY_5_3, isY_6_2, isY_6_4, isY_7_2 }) {
  return (
    <s.OrderDetailDiv>
      <dl>
        <s.OrderDetailDt>見積番号</s.OrderDetailDt>
        <s.OrderDetailDd>{data?.request.MitsumoriNo}</s.OrderDetailDd>
        <s.OrderDetailDt>車名</s.OrderDetailDt>
        <s.OrderDetailDd>{data?.request.CarName}</s.OrderDetailDd>
        <s.OrderDetailDt>車輌型式</s.OrderDetailDt>
        <s.OrderDetailDd>{data?.request.Sharyo_Katashiki}</s.OrderDetailDd>
        <s.OrderDetailDt>年式</s.OrderDetailDt>
        <s.OrderDetailDd>{data?.request.Sharyo_Nenshiki}</s.OrderDetailDd>
        {data?.request.Sai_MitsumoriNo && (
          <>
            <s.OrderDetailDtOrder>前回の見積番号</s.OrderDetailDtOrder>
            <s.OrderDetailDd>
              <a href={`/ordereddetail/Y-7-2/${data?.request.Sai_MitsumoriNo}`}>
                <s.FontElement>{data?.request.Sai_MitsumoriNo}</s.FontElement>
              </a>
            </s.OrderDetailDd>
            <s.OrderDetailDt>再見積の理由</s.OrderDetailDt>
            <s.OrderDetailDd>
              <s.FontElementReason>{data?.request.Sai_Reason}</s.FontElementReason>
            </s.OrderDetailDd>
          </>
        )}

        <s.OrderDetailDtOrder>見積依頼部品</s.OrderDetailDtOrder>
        <s.OrderDetailDd>{isY_5_label ? data?.PartsName : !data?.request.GenshaID || data?.request.GenshaID == null ? data?.PartsName : "指定依頼"}</s.OrderDetailDd>
      </dl>
    </s.OrderDetailDiv>
  );
}
